module.exports = __webpack_public_path__ + "img/trezor.0ebab6e6.svg";